import React from 'react';

interface IProps {
  name: string;
  value: string;
  placeholder?: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  type?: string;
  onclick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const InputBox = (props: IProps) => {
  const { name, value, placeholder, handleChange, error, type, onclick, disabled, style } = props;
  return (
    <>
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={handleChange}
        onClick={onclick}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        className="block w-full h-[35px] md:h-[30px]  rounded-lg border-0 md:pt-4 pt-5 pb-5 pr-[40px] pl-5  shadow-sm bg-[#343434] placeholder:text-[#F3F3E099] placeholder:font-normal md:text-sm text-xs sm:leading-[28.13px]"
        style={style}
      />
      <div
        className={`block sm:h-[16px] h-[10px] ${error && `mb-3`}  font-normal text-[10px] md:text-sm`}
      >
        {error && <p className="error ps-1 text-[#ff4c4c]">{error}</p>}
      </div>
    </>
  );
};

export default InputBox;
